var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GroupMembersCard',{attrs:{"grupo":_vm.grupo,"integrantes":_vm.integrantes},on:{"reload":_vm.reloadGrupo}})
}
var staticRenderFns = []

export { render, staticRenderFns }